import { AlertCircle } from 'lucide-react';

/** Inline error message under a form field. */
export default function FieldError({ message, className = 'mt-2' }) {
  if (!message) return null;
  return (
    <div className={`flex items-center gap-1 text-red-600 text-sm ${className}`}>
      <AlertCircle className="w-4 h-4" />
      <span>{message}</span>
    </div>
  );
}
